import { Dispatch } from 'react';

interface SearchActionTypes {
    updateParameter: string;
    triggerSearch: string;
}

// Filtros e paginação das telas de consulta: todo search-reducer trata updateParameter e triggerSearch
export function useSearchActions<P extends { page: number; pageSize: number }>(dispatch: Dispatch<any>, actionTypes: SearchActionTypes, emptyFilters: Partial<P>) {
    function updateParameters(patch: Partial<P>) {
        dispatch({ type: actionTypes.updateParameter, payload: patch });
    }

    function triggerSearch() {
        dispatch({ type: actionTypes.triggerSearch });
    }

    function handleSearch() {
        updateParameters({ page: 0 } as Partial<P>);
        triggerSearch();
    }

    function handleClearFilters() {
        updateParameters({ ...emptyFilters, page: 0 });
        triggerSearch();
    }

    function handlePaginationChange(page: number, pageSize: number) {
        updateParameters({ page, pageSize } as Partial<P>);
        triggerSearch();
    }

    return { updateParameters, triggerSearch, handleSearch, handleClearFilters, handlePaginationChange };
}
